import React from "react";

export default function CardLayout({ children }) {
  return (
    <div className="card border-0">
      <div className="card-body">{children}</div>
    </div>
  );
}
